// src/components/Layout.js
import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "./apiConfig";

// Import logo and CSS
import logo from "../assets/HaribalajiLogo.png";
import "../App.css"; // 👈 Import the CSS here

function Layout() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [companyData, setCompanyData] = useState({
    companyName: "HARI BALAJI TRADERS",
    companyLogo: logo
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Fetch company data
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}api/Crackers/GetMinimumOrderAmount?companyId=3`);
        if (response.data.statusCode === 200 && response.data.data) {
          const data = response.data.data;
          
          // Handle logo URL - prepend base URL if it's a relative path
          let logoUrl = data.companyLogo || null;
          if (logoUrl && !logoUrl.startsWith('http')) {
            // Remove leading slash if present
            logoUrl = logoUrl.startsWith('/') ? logoUrl.substring(1) : logoUrl;
            logoUrl = `${API_BASE_URL}${logoUrl}`;
          }
          
          setCompanyData({
            companyName: data.companyName || "HARI BALAJI TRADERS",
            companyLogo: logoUrl
          });
        }
      } catch (error) {
        console.error('Error fetching company data:', error);
      }
    };
    fetchCompanyData();
  }, []);

  // Hide navbar on homepage
  if (location.pathname === "/") {
    return null;
  }

  return (
    <header className="header"> {/* All styles from App.css will apply */}
      <div className="logo-container">
        <img src={companyData.companyLogo} alt={companyData.companyName} />
        <h2 style={{ margin: "0 0 0 10px", fontSize: "16px", color: "#fff7f7ff" }}>
          {companyData.companyName}
        </h2>
      </div>
      <nav className="nav">
        <ul>
          <li>
            <NavLink to="/Dashboard" className={({ isActive }) => (isActive ? "active" : undefined)}>
              Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/Admin_Category" className={({ isActive }) => (isActive ? "active" : undefined)}>
              Category Management
            </NavLink>
          </li>
          <li>
            <NavLink to="/Admin_Product" className={({ isActive }) => (isActive ? "active" : undefined)}>
              Product Management
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/Admin_Order"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              Order Management
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/Admin_Company"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              Company Settings
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/Home"
              className={({ isActive }) => (isActive ? "active login-link" : "login-link")}
            >
              Log Out
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Layout;